import { createAction, props } from '@ngrx/store';
import { CustomerSpecificationTypeEntity } from '../../entities/customerSpecificationType.entity';
import {
    DaveMutationChangeChartOfAccountArgs, DaveMutationChangeCustomerSpecificationTypeArgs,
    DaveMutationCreateChartOfAccountArgs, DaveMutationCreateCustomerSpecificationTypeArgs,
    DaveMutationDeleteChartOfAccountArgs, DaveMutationDeleteCustomerSpecificationTypeArgs,
} from '../../graphql-types';
import { ChartOfAccountEntity } from '../../entities/chart-of-Account.entity';
import { prefix } from '@fortawesome/free-solid-svg-icons';


export const CustomerSpecificationTypeActionTypes = {
    UpdateCustomerSpecificationType: createAction(
        'data/CustomerSpecificationType/update',
        props<{ Payload: Array<CustomerSpecificationTypeEntity> }>(),
    ),
    GetCustomerSpecificationTypeRequest: createAction(
        'data/CustomerSpecificationType/getAll',
    ),

    ChangeCustomerSpecificationType: createAction(prefix + 'change', props<{ Payload: DaveMutationChangeCustomerSpecificationTypeArgs }>()),
    ChangeSuccess: createAction(prefix + 'Change/success', props<{ Payload: CustomerSpecificationTypeEntity }>()),
    ChangeFailure: createAction(
        prefix + 'Change/failure',
        props<{
            Payload: { Errors: any; ToasterMessage?: string };
        }>(),
    ),

    Add: createAction(prefix + 'add', props<{ Payload: DaveMutationCreateCustomerSpecificationTypeArgs }>()),
    AddSuccess: createAction(prefix + 'Add/success', props<{ Payload: CustomerSpecificationTypeEntity }>()),
    AddFailure: createAction(prefix + 'Add/failure', props<{ Payload: { Errors: any; ToasterMessage?: string } }>()),

    Delete: createAction(prefix + 'delete', props<{ Payload: DaveMutationDeleteCustomerSpecificationTypeArgs }>()),
    DeleteSuccess: createAction(prefix + 'removeOne', props<{ Payload: number }>()),
    DeleteFailure: createAction(prefix + 'Add/failure', props<{ Payload: { Errors: any; ToasterMessage?: string } }>()),
};

